export const IFP_CHARGE_AMOUNT = 120
